var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11103 5.83328C6.11103 5.21963 6.60849 4.72217 7.22214 4.72217H12.7777C13.3913 4.72217 13.8888 5.21963 13.8888 5.83328V9.16661C13.8888 9.78026 13.3913 10.2777 12.7777 10.2777H7.22214C6.60849 10.2777 6.11103 9.78026 6.11103 9.16661V5.83328ZM7.7777 8.61106V6.38883H12.2221V8.61106H7.7777Z",
    fill: "#71869D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11103 11.9444C6.11103 11.4842 6.48413 11.1111 6.94436 11.1111H8.61103C9.07127 11.1111 9.44436 11.4842 9.44436 11.9444C9.44436 12.4046 9.07127 12.7777 8.61103 12.7777H6.94436C6.48413 12.7777 6.11103 12.4046 6.11103 11.9444Z",
    fill: "#71869D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3888 11.1111C10.9286 11.1111 10.5555 11.4842 10.5555 11.9444C10.5555 12.4046 10.9286 12.7777 11.3888 12.7777H13.0555C13.5157 12.7777 13.8888 12.4046 13.8888 11.9444C13.8888 11.4842 13.5157 11.1111 13.0555 11.1111H11.3888Z",
    fill: "#71869D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11103 14.4444C6.11103 13.9842 6.48413 13.6111 6.94436 13.6111H8.61103C9.07127 13.6111 9.44436 13.9842 9.44436 14.4444C9.44436 14.9046 9.07127 15.2777 8.61103 15.2777H6.94436C6.48413 15.2777 6.11103 14.9046 6.11103 14.4444Z",
    fill: "#71869D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3888 13.6111C10.9286 13.6111 10.5555 13.9842 10.5555 14.4444C10.5555 14.9046 10.9286 15.2777 11.3888 15.2777H13.0555C13.5157 15.2777 13.8888 14.9046 13.8888 14.4444C13.8888 13.9842 13.5157 13.6111 13.0555 13.6111H11.3888Z",
    fill: "#71869D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.38881 2.22217C4.70127 2.22217 3.33325 3.59019 3.33325 5.27772V14.7222C3.33325 16.4097 4.70127 17.7777 6.38881 17.7777H13.611C15.2986 17.7777 16.6666 16.4097 16.6666 14.7222V5.27772C16.6666 3.59019 15.2986 2.22217 13.611 2.22217H6.38881ZM4.99992 5.27772C4.99992 4.51066 5.62175 3.88883 6.38881 3.88883H13.611C14.3781 3.88883 14.9999 4.51066 14.9999 5.27772V14.7222C14.9999 15.4892 14.3781 16.1111 13.611 16.1111H6.38881C5.62175 16.1111 4.99992 15.4892 4.99992 14.7222V5.27772Z",
    fill: "#71869D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalculator);
export default __webpack_public_path__ + "static/media/iconCalculator.0d11e23e135c61071eaad239977ff180.svg";
export { ForwardRef as ReactComponent };